import React, { useEffect, useState } from "react";
import StablePrime from "../components/Tables/StablePrime";
import { useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

function DynamicStable({ setPageHeader, urlData, url = "/dynamicstable" }) {
  setPageHeader();
  let { typ } = useParams();
  let { subtyp } = useParams();
  const [loading, setLoading] = useState(true);
  const [paramData, setParamsData] = useState();
  const { search } = useLocation();
  const searchParams = queryString.parse(search);


  useEffect(() => {
    setLoading(true);
    let _urlData = { ...searchParams, typ: typ, subTyp: subtyp, ...urlData };
    setParamsData(_urlData);;
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [typ, subtyp, urlData]);


  return !loading && (
    <div>
      {
        searchParams.tblQty ?
          Array.from({ length: searchParams.tblQty }).map((_, i) => (
            <div style={{ minHeight: 400, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <StablePrime editSingleColumn={true} url={url}
                data={{ ...paramData, tblIndx: `table-${i}` }}
                zenTable={true}
                identity="" />
            </div>
          )) :
          <StablePrime editSingleColumn={true} url={url}
            data={paramData}
            zenTable={true}
            identity="" />
      }
      {/* <Stable url="report/tom" data={{}} identity="perfparam" /> */}
    </div>
  );
}

export default DynamicStable;
